import React from 'react';
import { Row, Col } from '../../util_grid/grid.js';
import Layout_base from './layout-base.jsx';

class Layout_two  extends Layout_base {
  render() {
    return (
      <Col xs={12} className="generic__two">
        {this.sectionHead()}
        <Row>
          <Col xs={12} md={6}>{this.componentDOM(0)}</Col>
          <Col xs={12} md={6}>{this.componentDOM(1)}</Col>
        </Row>
        {this.sectionFooter()}
      </Col>
    );
  }
}

export default Layout_two;
